import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/emailVerification.css';

const EmailVerificacao = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitEnviarEmailVerificacao (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            email
        });

        try {
            const response = await fetchFlask('codigoVerificacaoEmail', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setEmail('');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const completedFields = [email].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Enviar Código de Verificação
            </PageHeader>

            <form action='' method='POST' id='formCodigoVerificacao' onSubmit={submitEnviarEmailVerificacao} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Envio de código para validação do e-mail</h2>
                        </Box>
                        <p>
                            Informe o endereço do cliente para disparar o código usado na verificação cadastral.
                        </p>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <MailOutlineRoundedIcon />
                            <Box>
                                <span>Etapa 1</span>
                                <strong>Destinatário</strong>
                            </Box>
                        </Box>

                        <TextField
                            required
                            type='email'
                            label='E-mail'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Box>

                    <Box className='email-verification-signal'>
                        <VerifiedUserRoundedIcon />
                        <Box>
                            <span>Finalidade</span>
                            <strong>Código temporário de confirmação</strong>
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do envio</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>E-mail</span>
                            <strong className={!email ? 'is-empty' : undefined}>{email || 'Não informado'}</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <MarkEmailReadRoundedIcon />
                        <p>
                            Confira o endereço antes de enviar. O código será usado pelo cliente para confirmar o e-mail informado.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Enviar E-mail
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default EmailVerificacao;
